var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ppv2-p-6"},[(!_vm.isLoading)?_c('PrestationTagForm',{attrs:{"editItem":_vm.editItem},on:{"success":_vm.handleSuccess,"cancel":_vm.handleCancel}}):_c('div',{staticClass:"ppv2-flex ppv2-justify-center ppv2-py-10"},[_c('span',{staticClass:"ppv2-text-gray-500"},[_vm._v(_vm._s(_vm.$t('tag.loading')))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }